import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 6);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : '';
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              最受读者欢迎的私密健康科普内容
            </p>
          </div>
          <Link
            to="/category/shengli-jiegou"
            className="text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              image={article.image}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              readTime={article.readTime}
              publishedAt={article.publishedAt}
            />
          ))}
        </div>
      </div>
    </section>
  );
}